__turbopack_context__.v({
  "menu": "DropdownMenu-module-scss-module__brIY3G__menu",
});
